import { useReducer } from 'react';

import { GridState, GridAction } from '../types';

const gridReducer = (state: GridState, action: GridAction): GridState => {
  switch (action.type) {
    case 'SET_DATA':
      return {
        ...state,
        rows: action.payload.rows,
        rowCount: action.payload.rowCount,
        hasNextPage: action.payload.hasNextPage,
        loading: false,
      };
    case 'SET_LOADING':
      return { ...state, loading: true };
    default:
      return state;
  }
};

export const useGridState = (initialData?: {
  rows: any[];
  totalCount: number;
}) => {
  return useReducer(gridReducer, {
    rows: initialData?.rows ?? [],
    rowCount: initialData?.totalCount ?? 0,
    loading: !initialData,
  });
};
